import { Subscription, subscriptionToSubscriptionUpdateDTO } from '@teammood/shared/util/core';
import { TeamForAdmin, TeamForAdminDTO, teamForAdminDTOToTeamForAdmin } from '.';
import { Injectable } from '@angular/core';
import { LoggerService } from '@teammood/shared/util/logger';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TeamForAdminService {
  constructor(
    private http: HttpClient, 
    private logger: LoggerService
  ) { }

  async get(teamId: string): Promise<TeamForAdmin> {
    const response = await firstValueFrom(this.http.get<TeamForAdminDTO>(`/admin/team/${teamId}`));
    return teamForAdminDTOToTeamForAdmin(response);
  }

  async updateYearlySubscription(teamId: string, subscription: Subscription): Promise<void> {
    const subscriptionDto = subscriptionToSubscriptionUpdateDTO(subscription);
    try {
      await firstValueFrom(this.http.put<string>(`/admin/subscription/${teamId}/Yearly`, subscriptionDto));
    } catch (error) {
      this.logger.error(error.data);
      throw error;
    }
    return;
  }

  async switchToTrial(team_id: string) {
    try {
      await firstValueFrom(this.http.put<string>(`/admin/subscription/${team_id}/Trial`, {}));
    } catch (error) {
      this.logger.error(error.data);
      throw error;
    }
    return;
  }

  async extendsTrialPeriod(team_id: string, duration: 'week' | 'month') {
    try {
      await firstValueFrom(this.http.get<string>(`/admin/trial/extend/${team_id}/${duration}`));
    } catch (error) {
      this.logger.error(error.data);
      throw error;
    }
    return;
  }

  async disable(team_id: string) {
    try {
      await firstValueFrom(this.http.get<string>(`/admin/disable/${team_id}`));
    } catch (error) {
      this.logger.error(error.data);
      throw error;
    }
    return;
  }

  async delete(team_id: string) {
    try {
      await firstValueFrom(this.http.delete<string>(`/admin/team/${team_id}`));
    } catch (error) {
      this.logger.error(error.data);
      throw error;
    }
    return;
  }

  async pushRenewalToCrm(team_id: string) {
    try {
      await firstValueFrom(this.http.post<string>(`/admin/yearly_renew/${team_id}`, {}));
    } catch (error) {
      this.logger.error(error.data);
      throw error;
    }
    return;
  }

  async pushOutreachToCrm(team_id: string) {
    try {
      await firstValueFrom(this.http.post<string>(`/admin/trial_outreach/${team_id}`, {}));
    } catch (error) {
      this.logger.error(error.data);
      throw error;
    }
    return;
  }

  async toggleFeature(team_id: string, feature_id: string) {
    try {
      await firstValueFrom(this.http.put<string>(`/admin/feature/${team_id}/${feature_id}`, {}));
    } catch (error) {
      this.logger.error(error.data);
      throw error;
    }
    return;
  }

  updateContact(team_id: string, newContact: string): Observable<string> {
    try {
      return this.http.put<string>(`/admin/contact/${team_id}`, {contact: newContact});
    } catch (error) {
      this.logger.error(error.data);
      throw error;
    }
  }
}